import { DataField, InsightField } from '@/types/automationFields.ts';
import { StepError } from '@/types/automationSteps.ts';
import { Fragment, ReactNode } from 'react';

const getExtractionFieldIdentifier = (
  extractionFields: DataField[] | InsightField[],
  index: number | null,
): string => {
  if (index === null || index >= extractionFields.length) {
    return '';
  }
  const field = extractionFields[index];

  if (!field || !field.name) {
    return `Field ${index + 1}:`;
  }
  return `Field ${field.name}:`;
};

export const makeErrorMessageString = (
  errors: StepError[],
  extractionFields: DataField[] | InsightField[],
): ReactNode | undefined => {
  if (errors.length === 0) {
    return undefined;
  }

  const errorMessages = errors.map(
    (error) => `${getExtractionFieldIdentifier(extractionFields, error.index)} ${error.message}`,
  );
  return (
    <>
      {errorMessages.map((errorMessage, index) => (
        <Fragment key={`${errorMessage}-${index}`}>
          {errorMessage}
          <br />
        </Fragment>
      ))}
    </>
  );
};
